import React, {PropTypes} from 'react';
import EntryContainer from './EntryContainer.jsx';
import classNames from 'classnames';

const EntryList = ({
  entries,
  onSelectChecked,
  teamOwnedVirtualEntriesAvailable
}) => (
  <div> 
    { teamOwnedVirtualEntriesAvailable.length > 0 ?
      <table className="info-summary">
        <thead>
          <tr>
            <th />
            <th>Virtual Event Name</th>
            <th>Available Entries</th>
            <th>Total Entries</th>
            <th>Balance Due</th>
          </tr>
        </thead>
        <tbody>
          {teamOwnedVirtualEntriesAvailable.map((entry, index) => (
            <tr key={index}
            className={classNames({'bg-warning': entry.balanceDue})}>
              <td>
                <div className="list-group-item-labeled-child custom-checkbox-container"
                  style={{width: 25}}>
                  <input
                    type="checkbox"
                    id={`entry-${entry.virtualEventId}`}
                    disabled={!entry.balanceDue}
                    checked={entry.selected}
                    onChange={() => onSelectChecked(entry.virtualEventId)}
                  />
                  <label htmlFor={`entry-${entry.virtualEventId}`} />
                </div>
              </td>
              <td>{entry.virtualEventName}</td>
              <td>{entry.availableEntries}</td>
              <td>{entry.totalEntries}</td>
              <td>
                <div className={classNames(
                    'list-group-item-labeled-child',
                    {'bg-danger': entry.balanceDue}
                  )}
                  style={{width: 110, borderRadius: 25}}>
                  {entry.balanceDue
                    ? <button className="btn btn-link bg-danger bold-font"
                      type="button"
                      disabled
                      style={{color: '#000'}}>
                        {`$${entry.balanceDue.formatCurrency(2)} DUE`}
                      </button>
                    : null
                  }
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    : null}
    <div className="list-group">
      {entries.map((item, index) => (
        <EntryContainer
          key={index}
          zindexvalue={entries.length + 1003 - index} // Stack zIndex inversely to prevent hiding dropdowns
          {...item}
        />
      ))}
    </div>
  </div>
);

EntryList.propTypes = {
  entries: PropTypes.arrayOf(PropTypes.object),
  onSelectChecked: PropTypes.func,
  teamOwnedVirtualEntriesAvailable: PropTypes.arrayOf(PropTypes.object)
};

export default EntryList;



// WEBPACK FOOTER //
// ./src/features/registration/manage/EntryList.jsx